var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-json-pretty',{attrs:{"data":_vm.data,"deep":_vm.open ? Number.Infinity : 0,"showLength":true}})}
var staticRenderFns = []

export { render, staticRenderFns }